import React, { useState, useEffect } from 'react'
import { toastr } from 'react-redux-toastr'
import { Button, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { connect } from 'react-redux'
import _, { map } from 'lodash'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import moment from 'moment'

import ManageAssetsContainer from '../../smart/menuComponentsContainer/ManageAssetsContainer'
import AddAssetContainer from '../../smart/menuComponentsContainer/AddAssetContainer'
import SearchBar from './SearchBar'

import { getCompanyById } from '../../../action/CompaniesActions'
import { /* getAllDevices, */ getDevicesList } from '../../../action/DeviceActions'
// import { apiCallGet } from '../../../action/RouterActions'
// import ModalUpgradeFirmwareBatch from '../../smart/modals/ModalUpgradeFirmwareBatch'
import ModalChangeConfBatch from '../../smart/modals/ModalChangeConfBatch'
import ModalFormatSDBatch from '../../smart/modals/ModalFormatSDBatch'
import { getDeviceDataLimit } from '../../helpers/helperVehicle'
import { isInternalUser } from '../../helpers/constants'
import { cameraHealthIcons } from '../../helpers/iconHelpers'

import './manageVehicles.sass'
import CustomButton from '../../CustomButton'
import { CustomButtonToggle } from '../../DropdownComponents'
import { columnSelectIcon } from '../../helpers/iconHelpers'

const ManageAssets = (props) => {

	const { user, company, toggleLoader, goToCameraHealth, updateHasUnacknowledgedAlerts } = props;
	const userRole = user.roles[0];

	const [searchText, setSearchText] = useState('');
	const [devices, setDevices] = useState([]);
	const [initialData, setInitialData] = useState([]);
	const [companyData, setCompanyData] = useState({});
	const [highlightData, setHighlightData] = useState(false);
	const [lastFirmwarePackages, setLastFirmwarePackages] = useState([]);
	const [showUpdateProfile, setShowUpdateProfile] = useState(false)
	const [showUpdateFirmware, setShowUpdateFirmware] = useState(false)
	const [showFormatStorage, setShowFormatStorage] = useState(false)
	const [columns, setColumns] = useState(JSON.parse(localStorage.getItem('vehicleColumns')) || {
		channelStatus: true,
		group: true,
		configProfile: true,
		onlineStatus: true,
		totalDataUsage: true,
		streamDataUsage: false,
		liveStream: true,
		recordingStatus: !isInternalUser(userRole),
		// firmwareStatus: true,
		firstConnected: false,
		id: false,
		vinNumber: false,
		plateNumber: false,
		imei: false,
		auditLog: false,
		no_sd_card: false,
	});
	const [selectedDevices, setSelectedDevices] = useState([]);

	const [sortDevicesName, setSortDevicesName] = useState('vehicle_name');
	const [sortDevicesOrder, setSortDevicesOrder] = useState('asc');

	useEffect(() => {
		setSearchText('');
		getCompanyDevices();
		setLastViewedAssetsList();

		return () => {
			setLastViewedAssetsList();
			setSelectedDevices([]);
		}
	}, [company.company_id]);

	const getCompanyDevices = () => {
		toggleLoader(true);

		if (!company || (!company.name || !company.company_id)) {
			toggleLoader(false)
			return
		}

		const requestArray = [];
		requestArray.push(getCompanyById(userRole, company.company_id));
		// requestArray.push(getAllDevices(userRole, company.name, company.partner, null, true, 'sd_status,channel_status,data_usage,ignition,latest_hdderror'));
		requestArray.push(getDevicesList(company.company_id, 'inactive_devices,latest_hdderror,data_usage,ignition,sd_status,channel_status,driver,live_stream,no_sd_card,camera_health'));
		// userRole !== 'custom_user' && requestArray.push(apiCallGet('/firmware/last/packages'));
		const cameraHealthWarn = devices.reduce((errors, vehicle) => {
			return errors + vehicle.camera_health.warn
		}, 0)
		const cameraHealthCrit = devices.reduce((errors, vehicle) => {
			return errors + vehicle.camera_health.crit
		}, 0)
		// The Camera Health tab will have a red dot (bubble) indicator when there are unacknowledged errors on any camera, FWSD-6457
		let hasUnacknowledgedAlerts = false
		Promise.all(requestArray)
			.then(res => {
				const companyData = res[0].data.response.company;
				const initDevices = res[1].data.response.devices.map((item) => {
					item.cameraError = (item.channel_status && item.channel_status.length && item.channel_status.find(channel => channel.fail_ts > (channel.success_ts || '1970-01-01 00:00:00') && item.channel_available.includes(channel.channel))) ? 1 : 0;

					item.recordingError = (!_.isEmpty(item.latest_hdderror) && item.latest_hdderror.count) > 0 ? 1 : 0
					// FWSD-5221
					item.liveStreamError = item.live_stream.duration_month > 6000 ? 1 : 0

					// FWSD-4314 - If device does not receive GPS from device and ignition is Off more 24 hours (1440 mins) then display Online status.
					// Device stopped receive GPS, broken antena or something, and FileServer does not know when ignition is On.
					// if ((row.ignition && row.ignition.state) || (!row.gps_online && durationInMins > 1440)) {
					let onlineStatus = 'parking'
					if (!item.online) {
						onlineStatus = 'offline'
					}
					else {
						const ignitionOffTS = item.ignition && item.ignition.ts ? item.ignition.ts : ''; // 2023-01-04 18:50:37
						const duration = moment.duration(moment.utc().diff(moment.utc(ignitionOffTS), 'seconds'), 'seconds')
						const durationInMins = duration.asMinutes()

						if ((item.ignition && item.ignition.state) || (!item.gps_online && durationInMins > 1440)) {
							onlineStatus = 'online'
						}
					}
					item.onlineStatus = onlineStatus

					if (!hasUnacknowledgedAlerts && item.camera_health && item.camera_health.unacknowledged > 0) {
						hasUnacknowledgedAlerts = true
					}

					return item;
				})
				// const last_firmware_packages = res[2] && res[2].data.response.last_firmware_packages

				setCompanyData(companyData)
				// setLastFirmwarePackages(last_firmware_packages)
				setInitialData(initDevices)
				updateHasUnacknowledgedAlerts(hasUnacknowledgedAlerts)

				searchText ? dataSearch() : setDevices(initDevices);

				toggleLoader(false)
			})
			.catch(error => {
				toggleLoader(false)
				toastr.error('There was an issue getting your available vehicles. Please try again later.')
			})
	}

	const dataSearch = (e) => {
		const value = e ? e.target.value.toLowerCase() : searchText;
		const searchedDevices = _.cloneDeep(initialData).filter(device => {
			return (
				(device.device_id && device.device_id.toString().toLowerCase().includes(value))
				|| (device.vehicle_name && device.vehicle_name.toLowerCase().includes(value))
				// || (device.driver_name && device.driver_name.toLowerCase().includes(value))
				|| (device.group_name && device.group_name.toLowerCase().includes(value))
				|| (device.vin_number && device.vin_number.toLowerCase().includes(value))
				|| (device.serial_number && device.serial_number.toLowerCase().includes(value))
				|| (device.tag_plate && device.tag_plate.toLowerCase().includes(value))
			)
		})

		setDevices(searchedDevices)
		setSearchText(value)
	}

	const toggleCheckbox = ({ target }) => {
		const { name, checked } = target;
		ReactGA.event({
			category: userRole,
			action: 'Select Column',
			label: (checked ? 'Add ' : 'Remove ') + name
		})
		const updatedColumns = { ...columns, ...{ [name]: checked } }
		setColumns(updatedColumns);
		localStorage.setItem('vehicleColumns', JSON.stringify(updatedColumns))
	}

	const selectDevice = (row) => {
		ReactGA.event({
			category: userRole,
			action: 'Toggle Devices',
			label: 'Select One Device'
		})

		selectedDevices.includes(row.device_id) ?
			setSelectedDevices(selectedDevices.filter((id) => id !== row.device_id)) :
			setSelectedDevices([...selectedDevices, row.device_id])
	}

	const selectDevicesByError = (errType) => {
		let newSelectedDevices = [];
		let sortedDevices = devices;
		switch (errType) {
			case 'channel_status':
				// devices.forEach(e => {
				// 	if (e.channel_status.length) {
				// 		(e.channel_status.filter(channel => channel.fail_ts > (channel.success_ts|| '1970-01-01 00:00:00')).length ? newSelectedDevices.push(e) : null)
				// 	}
				// })
				// sortedDevices = sortedDevices.sort((a,b) => newSelectedDevices.map(e => e.device_id).indexOf(a.device_id) > -1 ? -1 : 1)
				newSelectedDevices = devices.filter(vehicle => vehicle.cameraError)
				setSortDevicesName('cameraError');
				setSortDevicesOrder('desc');
				ReactGA.event({
					category: userRole,
					action: 'Toggle Devices',
					label: 'Channel Status Issue',
				})
				break;
			case 'sd_status':
				// newSelectedDevices = devices.filter(vehicle => vehicle.sd_status.recording_status === 'Needs Reformat')
				// sortedDevices = sortedDevices.sort((a,b) => a.sd_status.recording_status === 'Needs Reformat' ? -1 : 1)

				// newSelectedDevices = devices.filter(vehicle => !_.isEmpty(vehicle.latest_hdderror) && vehicle.latest_hdderror.count > 0)
				newSelectedDevices = devices.filter(vehicle => vehicle.recordingError)
				setSortDevicesName('recordingError');
				setSortDevicesOrder('desc');
				ReactGA.event({
					category: userRole,
					action: 'Toggle Devices',
					label: 'SD Reformat',
				})
				break;
			case 'data_limit':
				newSelectedDevices = devices.filter(vehicle => (vehicle.data_usage / 1024 / 1024 / 1024) > (getDeviceDataLimit(vehicle.data_limit, companyData)));
				setHighlightData(true);
				setSortDevicesName('data_usage');
				setSortDevicesOrder('desc');
				ReactGA.event({
					category: userRole,
					action: 'Toggle Devices',
					label: 'Data Over Limit',
				})
				break;
			case 'live_stream':
				newSelectedDevices = devices.filter(vehicle => vehicle.liveStreamError)
				setSortDevicesName('liveStreamError');
				setSortDevicesOrder('desc');
				ReactGA.event({
					category: userRole,
					action: 'Toggle Devices',
					label: 'Live Stream Over Limit',
				})
				break;
			case 'no_sd_card':
				newSelectedDevices = devices.filter(vehicle => !!vehicle.no_sd_card)
				setSortDevicesName('no_sd_card');
				setSortDevicesOrder('desc');
				ReactGA.event({
					category: userRole,
					action: 'Toggle Devices',
					label: 'SD Card Removal',
				})
				break;
			default:
				break;
		}

		newSelectedDevices = newSelectedDevices.map(vehicle => vehicle.device_id);
		if (_.isEqual(newSelectedDevices, selectedDevices)) {
			setSelectedDevices([])
		}
		else {
			newSelectedDevices.length && setSelectedDevices(newSelectedDevices)
		}
	}

	const selectAllDevices = (event) => {
		const { target } = event;
		const checked = target.type === 'checkbox' ? target.checked : target.value;
		let value = 'Deselect';

		let selectedDevices = []
		if (checked) {
			devices.map(device => { if (!!device.activated_timestamp) selectedDevices.push(device.device_id) });
			value = 'Select';
		}

		ReactGA.event({
			category: userRole,
			action: 'Toggle Devices',
			label: value + ' All Devices'
		})

		setSelectedDevices(selectedDevices)
	}

	const handleActionButton = (modalType) => {
		let value = '';

		if (selectedDevices.length) {
			switch (modalType) {
				case 'showUpdateProfile':
					setShowUpdateProfile(true)
					value = 'Open Update Profile'
					break;
				case 'showFormatStorage':
					setShowFormatStorage(true)
					value = 'Open Format SD'
					break;
				default:
					break;
			}
			ReactGA.event({
				category: userRole,
				action: 'Manage Vehicles Modal',
				label: value,
			})
		}
	}

	// const handleUpdateFirmwareButton = (outOfDateDevicesId) => {
	// 	if (outOfDateDevicesId.length) {
	// 		setShowUpdateFirmware(true)

	// 		ReactGA.event({
	// 			category: userRole,
	// 			action: 'Manage Vehicles Modal',
	// 			label: 'Open Update Firmware',
	// 		})
	// 	}
	// }

	const clearSelection = () => {
		// setShowUpdateFirmware(false)
		setShowUpdateProfile(false)
		setSelectedDevices([])
	}

	const filterColumn = (e, column, value) => {
		let newDevices = [];
		if (column === 'clear_all') {
			// FWSD-5030
			if (!devices.length) {
				setDevices(initialData);
			}
			else {
				setDevices([]);
			}
			ReactGA.event({
				category: userRole,
				action: 'Filter Column',
				label: 'Clear All'
			})
			return
		}

		if (!e.target.checked) {
			/* if (column === 'firmware_status' && value === 'firmware update') {
				newDevices = devices.filter(e => !e[column].includes('pending'))
			}
			else */
			// if (column === 'ignition') {
			// 	newDevices = devices.filter(e => !(e.online && (value ? (e.ignition && e.ignition.state === value) : ((e.ignition && e.ignition.state === value) || e.ignition === null))));
			// }
			// else if (column === 'sd_status') {
			// 	value === 'Needs Reformat' ?
			// 		newDevices = devices.filter(e => e.sd_status.recording_status !== 'Needs Reformat') :
			// 		newDevices = devices.filter(e => e.sd_status.recording_status === 'Needs Reformat')
			// }
			if (column === 'latest_hdderror') {
				value === 'Needs Reformat'
					? newDevices = devices.filter(e => _.isEmpty(e.latest_hdderror) || e.latest_hdderror.count === 0)
					: newDevices = devices.filter(e => !_.isEmpty(e.latest_hdderror) && e.latest_hdderror.count > 0)
			}
			else if (column === 'group_name') {
				newDevices = devices.filter(e => value === 'No group' ? (e.group_name && e.group_name.length) : e.group_name !== value);
			}
			else {
				newDevices = devices.filter(e => e[column] !== value);
			}
			e.target.checked = true;
		}
		else {
			/* if (column === 'firmware_status' && value === 'firmware update') {
				newDevices = [...initialData.filter(e => e[column].includes('pending')), ...devices];
			}
			else */
			// if (column === 'ignition') {
			// 	newDevices = [...initialData.filter(e => e.online && (value ? (e.ignition && e.ignition.state === value) : ((e.ignition && e.ignition.state === value) || e.ignition === null))), ...devices];
			// }
			// else if (column === 'sd_status') {
			// 	newDevices = [...devices];
			// 	value === 'Needs Reformat' ?
			// 		newDevices.unshift(...initialData.filter(e => e.sd_status.recording_status === 'Needs Reformat')) :
			// 		newDevices.unshift(...initialData.filter(e => e.sd_status.recording_status !== 'Needs Reformat'))
			// }
			if (column === 'latest_hdderror') {
				newDevices = [...devices];
				value === 'Needs Reformat' ?
					newDevices.unshift(...initialData.filter(e => !_.isEmpty(e.latest_hdderror) && e.latest_hdderror.count > 0)) :
					newDevices.unshift(...initialData.filter(e => _.isEmpty(e.latest_hdderror) || e.latest_hdderror.count === 0))
			}
			else if (column === 'group_name') {
				newDevices = [...initialData.filter(e => value === 'No group' ? (!e.group_name || !e.group_name.length) : e.group_name === value), ...devices];
			}
			else {
				newDevices = [...initialData.filter(e => e[column] === value), ...devices];
			}
			e.target.checked = false;
		}

		ReactGA.event({
			category: userRole,
			action: 'Filter Column',
			label: column + ': ' + value
		})
		setDevices(newDevices)
	}

	const filterConfigColumn = (e, value) => {
		let newDevices = [];
		if (!e.target.checked) {
			if (value !== 'Manual' && value !== 'Pending') {
				newDevices = devices.filter(e => e['uploaded_company_profile'] !== value);
			}
			else if (value === 'Pending') {
				newDevices = devices.filter(e => e['config_checksum'] !== 1)
			}
			else {
				newDevices = devices.filter(e => (e['config_checksum'] === 1 || (e['uploaded_company_profile'] !== 'Manual' && e['uploaded_company_profile'])))
			}
		}
		else {
			if (value !== 'Manual' && value !== 'Pending') {
				newDevices = [...initialData.filter(e => e['uploaded_company_profile'] === value), ...devices];
			}
			else if (value === 'Pending') {
				newDevices = [...initialData.filter(e => e['config_checksum'] === 1), ...devices];
			}
			else {
				newDevices = [...initialData.filter(e => (e['config_checksum'] !== 1 && (e['uploaded_company_profile'] === 'Manual' || !e['uploaded_company_profile']))), ...devices];
			}
		}
		setDevices(newDevices)
	}

	// const getLastFirmwarePackage = () => {
	// 	let lastPackageVersion = ''
	// 	if (lastFirmwarePackages && lastFirmwarePackages.length) {
	// 		lastFirmwarePackages.forEach((item) => {
	// 			if (item.version.substring(0, 3) === 'dv4') {
	// 				lastPackageVersion = item.version;
	// 			}
	// 		})
	// 	}

	// 	return lastPackageVersion
	// }

	// const getDeviceDataLimit = (deviceDataLimit) => {
	// 	let dataLimit = 1;
	// 	switch (deviceDataLimit) {
	// 		case 3:
	// 			dataLimit = 1;
	// 			break;
	// 		case 2:
	// 			dataLimit = 0.5;
	// 			break;
	// 		default:
	// 			dataLimit = companyData.data_limit === 2 ? 0.5 : 1;
	// 			break;
	// 	}
	// 	return dataLimit
	// }

	const setLastViewedAssetsList = () => {
		const { company, assets, updateLastViewedAssetsList } = props;
		if (company.company_id) {
			const { lastViewedVehiclesPage } = assets;
			const obj = lastViewedVehiclesPage.find(({ companyId }) => companyId === company.company_id)
			if (obj) {
				obj.ts = moment.utc().format('YYYYMMDDHHmmss')
			} else {
				lastViewedVehiclesPage.push({ companyId: company.company_id || '', ts: moment.utc().format('YYYYMMDDHHmmss') })
			}
			updateLastViewedAssetsList([...lastViewedVehiclesPage])
		}
	}

	const setDevicesSort = (sortName, sortOrder) => {
		setSortDevicesName(sortName);
		setSortDevicesOrder(sortOrder);
	}

	const canAddVehicles = ['system_admin', 'customer_service', 'provisioning'].includes(userRole);
	const { channelStatus, group, configProfile, onlineStatus, totalDataUsage, streamDataUsage, liveStream, recordingStatus, /* firmwareStatus, */ firstConnected, id, auditLog, vinNumber, plateNumber, imei, no_sd_card } = columns;
	const formatSDUser = ['fleet_manager', 'fleet_maintainer', 'group_manager', 'customer_service', 'partner', 'system_admin'].indexOf(userRole) > -1;

	const isSingleUsers = () => {
		const singleUsersList = ['fleet_maintainer', 'fleet_manager', 'group_manager', 'user', 'installer', 'partner_view', 'sales_demo', 'storage_manager', 'storage_user', 'custom_user', 'custom_partner']

		return singleUsersList.indexOf(userRole) !== -1
	}

	// const cameraErrors = devices.reduce((errors, vehicle) => {
	// 	return vehicle.channel_status.find(channel => channel.fail_ts > (channel.success_ts || '1970-01-01 00:00:00') && vehicle.channel_available.includes(channel.channel)) ? errors + 1 : errors;
	// }, 0)
	const cameraHealthWarn = devices.reduce((errors, vehicle) => {
		return vehicle.camera_health.warn ? errors + 1 : errors
	}, 0)
	const cameraHealthCrit = devices.reduce((errors, vehicle) => {
		return vehicle.camera_health.crit ? errors + 1 : errors
	}, 0)
	// FWSD-4382
	// const recordingErrors = !isInternalUser(userRole) ? 0 : devices.reduce((errors, vehicle) => {
	// 	// return vehicle.sd_status.recording_status === 'Needs Reformat' ? errors + 1 : errors
	// 	// return (!_.isEmpty(vehicle.latest_hdderror) && vehicle.latest_hdderror.count > 0) ? errors + 1 : errors
	// 	return errors + vehicle.recordingError
	// }, 0)
	const cameraErrors = devices.reduce((errors, vehicle) => {
		return errors + vehicle.cameraError
	}, 0)
	const dataUsageErrors = devices.reduce((errors, vehicle) => {
		return ((vehicle.data_usage / 1024 / 1024 / 1024) > (getDeviceDataLimit(vehicle.data_limit, companyData))) ? errors + 1 : errors
	}, 0)
	// const liveStreamErrors = devices.reduce((errors, vehicle) => {
	// 	return errors + vehicle.liveStreamError
	// }, 0)
	// const sdCardRemoval = devices.reduce((errors, vehicle) => {
	// 	return errors + vehicle.no_sd_card
	// }, 0)
	// const outOfDateDevices = devices.reduce((deviceIdArray, {serial_number, device_type, firmware_status, device_id}) => {
	// 	if (firmware_status === 'firmware out of date') {
	// 		deviceIdArray.push({ 'serial_number': serial_number, 'device_id': device_id, 'device_type': device_type })
	// 	}
	// 	return deviceIdArray
	// }, [])

	return (
		<div className="manage-vehicles">
			<div className="page-subheader manage-vehicles-subheader">
				<div className="subheader-section search">
					<SearchBar term={searchText} onSearch={dataSearch} placeholder="Search Vehicles..." />
				</div>
				<div className="subheader-section button-group">
					<CustomButton
						onClick={() => handleActionButton('showUpdateProfile')}
						disabled={!selectedDevices.length}
						variant='toggle-group'
					>
						Update Profile
					</CustomButton>
					{/* {userRole !== 'custom_user' &&
						<CustomButton
							onClick={() => handleUpdateFirmwareButton(outOfDateDevicesId)}
							disabled={!outOfDateDevicesId.length && getLastFirmwarePackage()}
							variant='toggle-group'
						>
							Update Firmware
						</CustomButton>
					} */}
					{formatSDUser &&
						<CustomButton
							onClick={() => handleActionButton('showFormatStorage')}
							disabled={!selectedDevices.length}
							variant='toggle-group'
							style={{ marginLeft: '2px' }}
						>
							Format SD
						</CustomButton>
					}
				</div>
				<Dropdown
					id="vehicle-select-dropdown"
					className="column-select-dropdown"
					role="menuitem"
					drop
				>
					<Dropdown.Toggle as={CustomButtonToggle} prefix="vehicle-select-dropdown" wrapperClassName="text-right" noCaret>
						{columnSelectIcon}
					</Dropdown.Toggle>
					<Dropdown.Menu className="vehicle-select-menu">
						<div className="vehicle-checkbox-group">
							<h5 className="category-title">Columns</h5>
							<div style={{ display: "flex" }}>
								<div className="col-sm-6">
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={channelStatus}
											name="channelStatus"
											onChange={toggleCheckbox}
										/>
										Channel Status
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={group}
											name="group"
											onChange={toggleCheckbox}
										/>
										Group
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={configProfile}
											name="configProfile"
											onChange={toggleCheckbox}
										/>
										Settings Profile
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={onlineStatus}
											name="onlineStatus"
											onChange={toggleCheckbox}
										/>
										Online Status
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={id}
											name="id"
											onChange={toggleCheckbox}
										/>
										ID
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={totalDataUsage}
											name="totalDataUsage"
											onChange={toggleCheckbox}
										/>
										Total Data Usage
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={streamDataUsage}
											name="streamDataUsage"
											onChange={toggleCheckbox}
										/>
										Stream Data Usage
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={liveStream}
											name="liveStream"
											onChange={toggleCheckbox}
										/>
										Live Stream
									</div>
								</div>
								<div className="col-sm-6">
									{!isInternalUser(userRole)
										? (
											<OverlayTrigger
												placement="bottom"
												delayHide={100}
												overlay={<Tooltip id="column-improvement-tooltip" className="tooltip custom-tooltips">Under Improvement</Tooltip>}
											>
												<div>
													<i className="fas fa-ban" />
													Recording Status
												</div>
											</OverlayTrigger>
										) : (
											<div>
												<input
													type="checkbox"
													className="vehicle-checkbox"
													checked={recordingStatus}
													name="recordingStatus"
													onChange={toggleCheckbox}
												/>
												Recording Status
											</div>
										)
									}
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={firstConnected}
											name="firstConnected"
											onChange={toggleCheckbox}
										/>
										First Connected
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={vinNumber}
											name="vinNumber"
											onChange={toggleCheckbox}
										/>
										VIN
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={plateNumber}
											name="plateNumber"
											onChange={toggleCheckbox}
										/>
										Plate Number
									</div>
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={imei}
											name="imei"
											onChange={toggleCheckbox}
										/>
										IMEI
									</div>
									{(userRole === 'system_admin' || userRole === 'customer_service') && (
										<div>
											<input
												type="checkbox"
												className="vehicle-checkbox"
												checked={auditLog}
												name="auditLog"
												onChange={toggleCheckbox}
											/>
											Audit Log
										</div>
									)}
									<div>
										<input
											type="checkbox"
											className="vehicle-checkbox"
											checked={no_sd_card}
											name="no_sd_card"
											onChange={toggleCheckbox}
										/>
										SD Card Removal
									</div>
								</div>
							</div>
						</div>
					</Dropdown.Menu>
				</Dropdown>
			</div>

			<main className="main-content-block">
				<section className="manage-vehicles-header">
					<div className="at-a-glance">
						<div className="at-a-glance-header">
							At A Glance
						</div>
						{/* {(cameraErrors || (outOfDateDevices.length && userRole !== 'custom_user') || recordingErrors || dataUsageErrors) */}
						{/* {(cameraHealthWarn ||  cameraHealthCrit || cameraErrors || recordingErrors || dataUsageErrors || liveStreamErrors || sdCardRemoval) */}
						{(cameraHealthWarn ||  cameraHealthCrit || cameraErrors || dataUsageErrors)
							? (
								<div className="icon-grid">
									{/* FWSD-7019 */}
									{/* {cameraHealthWarn > 0
										&& ( 
											<div className='icon-wrapper error-warn' onClick={goToCameraHealth}>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{cameraHealthWarn + ' cameras with warning health'}
														</Tooltip>
													}
												>
													<div>
														{cameraHealthIcons.cameraHealthWarn}
														<span className="alert-bubble">{cameraHealthWarn}</span>
													</div>
												</OverlayTrigger>
											</div>
									)}
									{cameraHealthCrit > 0
										&& ( 
											<div className='icon-wrapper error-crit' onClick={goToCameraHealth}>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{cameraHealthCrit + ' cameras with critical health'}
														</Tooltip>
													}
												>
													<div>
														{cameraHealthIcons.cameraHealthWarn}
														<span className="alert-bubble">{cameraHealthCrit}</span>
													</div>
												</OverlayTrigger>
											</div>
									)} */}
								
									{/* {userRole !== 'custom_user' && outOfDateDevicesId.length > 0
										&& (
											<div className='icon-wrapper'>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{outOfDateDevicesId.length + ' cameras need firmware update'}
														</Tooltip>
													}
												>
													<div>
														<svg
															width="3em"
															height="3em"
															viewBox="0 0 16 16"
															className="bi bi-cpu"
															fill="currentColor"
															xmlns="http://www.w3.org/2000/svg"
															onClick={() => handleUpdateFirmwareButton(outOfDateDevicesId)}
														>
															<path d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0zm-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>
														</svg>
														<span className="alert-bubble">{outOfDateDevicesId.length}</span>
													</div>
												</OverlayTrigger>
											</div>
										)
									} */}
									{/* {recordingErrors > 0
										&& (
											<div className='icon-wrapper'>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
																recordingErrors > 1 ? `${recordingErrors} cameras need reformatting`
																					: `${recordingErrors} camera needs reformatting`
															}
														</Tooltip>
													}
												>
													<div>
														<svg xmlns="http://www.w3.org/2000/svg" width="2.5em" height="2.5em" fill="currentColor" className="bi bi-sd-card" viewBox="0 0 16 16" onClick={() => selectDevicesByError('sd_status')}>
															<path d="M6.25 3.5a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2z" />
															<path fillRule="evenodd" d="M5.914 0H12.5A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5V3.914c0-.398.158-.78.44-1.06L4.853.439A1.5 1.5 0 0 1 5.914 0zM13 1.5a.5.5 0 0 0-.5-.5H5.914a.5.5 0 0 0-.353.146L3.146 3.561A.5.5 0 0 0 3 3.914V14.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-13z" />
														</svg>
														<span className="alert-bubble">{recordingErrors}</span>
													</div>
												</OverlayTrigger>
											</div>
									)} */}
									{cameraErrors > 0
										&& (
											<div className='icon-wrapper'>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{
																cameraErrors > 1 ? `${cameraErrors} cameras have status issues`
																				 : `${cameraErrors} camera has status issues`
															}
														</Tooltip>}
												>
													<div>
														<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" className="bi bi-camera" viewBox="0 0 16 16" onClick={() => selectDevicesByError('channel_status')}>
															<path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z" />
															<path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
														</svg>
														<span className="alert-bubble">{cameraErrors}</span>
													</div>
												</OverlayTrigger>
											</div>
										)}
									{dataUsageErrors > 0
										&& (
											<div className='icon-wrapper'>
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{/* {dataUsageErrors + ' cameras are over the data limit'} */
																dataUsageErrors > 1 ? `${dataUsageErrors} cameras are over the data limit`
																					: `${dataUsageErrors} camera is over the data limit`
															}
														</Tooltip>
													}
												>
													<div>
														<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" className="bi bi-bar-chart" viewBox="0 0 16 16" onClick={() => selectDevicesByError('data_limit')}>
															<path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z" />
														</svg>
														<span className="alert-bubble">{dataUsageErrors}</span>
													</div>
												</OverlayTrigger>
											</div>
										)}
									{/* {liveStreamErrors > 0
										&& (
											<div className="icon-wrapper">
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={(
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
																liveStreamErrors > 1 ? `${liveStreamErrors} cameras have exceeded the recommended monthly live stream time`
																					 : `${liveStreamErrors} camera has exceeded the recommended monthly live stream time`
															}
														</Tooltip>
													)}
												>
													<div>
														<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" className="bi bi-camera-video-off" viewBox="0 0 16 16" onClick={() => selectDevicesByError('live_stream')}>
															<path d="M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l.714 1H9.5a1 1 0 0 1 1 1v6a1 1 0 0 1-.144.518l.605.847zM1.428 4.18A.999.999 0 0 0 1 5v6a1 1 0 0 0 1 1h5.014l.714 1H2a2 2 0 0 1-2-2V5c0-.675.334-1.272.847-1.634l.58.814zM15 11.73l-3.5-1.555v-4.35L15 4.269v7.462zm-4.407 3.56-10-14 .814-.58 10 14-.814.58z" />
														</svg>
														<span className="alert-bubble">{liveStreamErrors}</span>
													</div>
												</OverlayTrigger>
											</div>
									)} */}
									{/* {sdCardRemoval > 0
										&& (
											<div className="icon-wrapper">
												<OverlayTrigger
													placement="bottom"
													delayHide={100}
													overlay={(
														<Tooltip id="tooltip" className="tooltip custom-tooltips">
															{`${sdCardRemoval} camera(s) report no SD card present`}
														</Tooltip>
													)}
												>
													<div>
														<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 32 32" fill="currentColor" version="1.1" x="0px" y="0px" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" onClick={() => selectDevicesByError('no_sd_card')}>
															<g transform="matrix(1,0,0,1,-333,-333)">
																<path d="M359.019,336L359,336C359,336 343.481,336 343.481,336C342.873,336 342.298,336.276 341.919,336.751C341.148,337.715 339.111,340.26 338.438,341.101C338.155,341.456 338,341.897 338,342.351L338,356.998L335.354,359.237C334.933,359.593 334.88,360.225 335.237,360.646C335.593,361.067 336.225,361.12 336.646,360.763L338,359.618L338,360C338,360.53 338.211,361.039 338.586,361.414C338.961,361.789 339.47,362 340,362C343.414,362 354.586,362 358,362C358.53,362 359.039,361.789 359.414,361.414C359.789,361.039 360,360.53 360,360L360,344C360,343.448 359.552,343 359,343C358.448,343 358,343.448 358,344L358,360L340,360L340,357.925L354.364,345.771C354.537,345.914 354.758,346 355,346C355.552,346 356,345.552 356,345L356,344.387L362.646,338.763C363.067,338.407 363.12,337.775 362.763,337.354C362.407,336.933 361.775,336.88 361.354,337.237L360,338.382L360,337C360,336.532 359.678,336.139 359.244,336.03L359.212,336.023L359.177,336.016L359.146,336.011L359.115,336.007L359.083,336.003L359.051,336.001L359.019,336ZM358,338L343.481,338L340,342.351L340,355.305L354,343.459L354,341C354,340.448 354.448,340 355,340C355.552,340 356,340.448 356,341L356,341.767L358.003,340.072C358.001,340.049 358,340.024 358,340L358,338ZM349,341L349,345C349,345.552 349.448,346 350,346C350.552,346 351,345.552 351,345L351,341C351,340.448 350.552,340 350,340C349.448,340 349,340.448 349,341ZM344,341L344,345C344,345.552 344.448,346 345,346C345.552,346 346,345.552 346,345L346,341C346,340.448 345.552,340 345,340C344.448,340 344,340.448 344,341Z" />
															</g>
														</svg>
														<span className="alert-bubble">{sdCardRemoval}</span>
													</div>
												</OverlayTrigger>
											</div>
									)} */}
								</div>
							) : (
								<div className="at-a-glance-message">No Camera Issues Detected</div>
							)
						}
						<div className="at-a-glance-footer text-center">
							<span className="total-assets"><strong>Total Cameras:</strong> {initialData.length}</span>
							<strong className="status-label online-label">Online:</strong> {initialData.filter(el => el.online && el.ignition && el.ignition.state).length}
							<strong className="status-label parked-label">Parked:</strong> {initialData.filter(el => el.online && (!el.ignition || !el.ignition.state)).length}
							<strong className="status-label">Offline:</strong> {initialData.filter(el => !el.online).length}
							{initialData[0]
								&& (
									<div>
										<div className="monthly-usage text-center">
											<strong>Monthly Data Usage:</strong> {initialData.reduce((a, b) => a + (b['data_usage'] / 1024 / 1024 / 1024 || 0), 0).toFixed(2) + ' GB'}
										</div>
										<div className="fleet-limit text-center">
											<strong>Fleet Data Limit:</strong> {initialData.reduce((a, b) => a + ((getDeviceDataLimit(b.data_limit, companyData)) || 1), 0) + ' GB'}
										</div>
										{['sales_demo', 'system_admin', 'customer_service'].indexOf(userRole) > -1 && (
											<div className="fleet-token text-center">
												<strong>Fleet Token:</strong> {company.token}
											</div>
										)}
									</div>
								)}
						</div>
					</div>
				</section>
				{!isSingleUsers()
					&& (
						<AddAssetContainer changedDevicesList={getCompanyDevices} devices={devices} />
					)}

				<div className="vehicle-table-header">
					<CustomButton variant="link" onClick={() => setSelectedDevices([])}>Clear All Selected {selectedDevices ? ('(' + selectedDevices.length + ')') : ''}</CustomButton>
				</div>
				<ManageAssetsContainer
					devices={devices}
					initialData={initialData}
					companyData={companyData}
					columns={columns}
					selectedDevices={selectedDevices}
					selectDevice={selectDevice}
					selectAllDevices={selectAllDevices}
					filterColumn={filterColumn}
					filterConfigColumn={filterConfigColumn}
					toggleCheckbox={toggleCheckbox}
					highlightData={highlightData}
					selectProfile={props.selectProfile}
					sortDevicesName={sortDevicesName}
					sortDevicesOrder={sortDevicesOrder}
					setDevicesSort={setDevicesSort}
					getCompanyDevices={getCompanyDevices}
				/>

				{showUpdateProfile && (
					<ModalChangeConfBatch
						userRole={userRole}
						companyData={companyData}
						selectedDevices={selectedDevices}
						clearSelection={clearSelection}
						onHide={() => setShowUpdateProfile(false)}
						getCompanyDevices={getCompanyDevices}
					/>
				)}

				{/* {showUpdateFirmware && (
					<ModalUpgradeFirmwareBatch
						userRole={userRole}
						outOfDateDevicesId={outOfDateDevicesId}
						lastFirmwarePackages={lastFirmwarePackages}
						clearSelection={clearSelection}
						onHide={() => setShowUpdateFirmware(false)}
						getCompanyDevices={getCompanyDevices}
					/>
				)} */}

				{showFormatStorage && (
					<ModalFormatSDBatch
						userRole={userRole}
						selectedDevices={selectedDevices}
						clearSelection={clearSelection}
						onHide={() => setShowFormatStorage(false)}
						getCompanyDevices={getCompanyDevices}
					/>
				)}
			</main>
		</div>
	);
}

ManageAssets.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	assets: PropTypes.objectOf(PropTypes.any).isRequired,
	updateLastViewedAssetsList: PropTypes.func.isRequired,
	goToCameraHealth: PropTypes.func.isRequired,
	updateHasUnacknowledgedAlerts: PropTypes.func.isRequired,
}

export default connect(
	({ user, company, assets }) => ({
		user: user.user,
		company: company.company,
		assets
	}),
	dispatch => ({
		updateLastViewedAssetsList: (state) => {
			dispatch({ type: 'SET_LAST_VIEWED_ASSETS', payload: state })
		},
		updateHasUnacknowledgedAlerts: (state) => {
			dispatch({ type: 'SET_HAS_UNACKNOWLEDGED_ALERTS', payload: state })
		},
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show })
		}
	})
)(ManageAssets);
